module.exports = __webpack_public_path__ + "img/fcmd3.06cdcd95.jpg";